import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Hooks and services
import { getPolicy } from '../../../../services/policy.service';

// Types
import { Policy } from '../../../../types/Policy';

// Components
import PolicyPermissions from './policyPermissions';

export default function PolicyOverview() {
  const { id } = useParams();
  const [policy, setPolicy] = useState<Policy>();

  if (!id) {
    return <>Really need an id</>;
  }

  useEffect(() => {
    getPolicy(id).then((response) => {
      if (response.status === 200) {
        setPolicy(response.data);
      }
    });
  }, [id]);

  if (policy === undefined) {
    return <>Waiting for policy to load...</>;
  }

  return (
    <>
      <h1>Policy: {policy.name}</h1>
      <PolicyPermissions policy={policy} setPolicy={setPolicy} />
    </>
  );
}
